import { Component, OnInit, ViewChild } from "@angular/core";
import { CardTableComponent } from "src/app/components/cards/card-table/card-table.component";
import { InventarioFilterEvent } from "src/app/models/filter";
import { ListColumn } from "src/app/models/list-columns.model";
import { AlertasSwalService } from "src/app/services/alerts.service";
import { InventarioService } from "./inventario.service";

@Component({
  selector: "app-inventario",
  templateUrl: "./inventario.component.html",
  styles: [],
})
export class InventarioComponent implements OnInit {
  public columns: ListColumn[] = [
    {
      name: "# Interno",
      property: "NoParteInterno",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "Desc",
      property: "Descripcion",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "Tipo Material",
      property: "TipoMaterial",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "Ubicacion",
      property: "Ubicacion",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "Cant",
      property: "Saldo",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "Minimo",
      property: "Minimo",
      visible: true,
      isModelProperty: true,
    },
  ];
  @ViewChild(CardTableComponent, { static: true })
  public tableComp: CardTableComponent;
  public ubicaciones = [];
  public tipos = [];
  realdata: any[] = [];

  // @ViewChild(UnidadForm, { static: true })
  // public formulario: UnidadForm;

  constructor(public service: InventarioService, private alerts: AlertasSwalService) {}

  ngOnInit(): void {
    this.loadRecords();
  }
  loadRecords() {
    this.service.get().subscribe(
      (resultData) => {
        this.ubicaciones = Array.from(
          new Set(resultData.map((m) => m.Ubicacion))
        ).sort();
        this.tipos = Array.from(
          new Set(resultData.map((m) => m.TipoMaterial))
        ).sort();
        this.realdata = resultData;
        this.filterdata(null);
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
  }

  filterdata(e: InventarioFilterEvent) {
    let filterdata = this.realdata;
    if (e != null) {
      let filtroTrimed = e.filter.toLocaleLowerCase().trim();
      if (e.tipo != "Todos")
        filterdata = filterdata.filter(
          (f) => (f.TipoMaterial as string).indexOf(e.tipo) > -1
        );

      if (e.ubicacion != "Todos")
        filterdata = filterdata.filter(
          (f) => (f.Ubicacion as string).indexOf(e.ubicacion) > -1
        );

      if (filtroTrimed.length > 0)
        filterdata = filterdata.filter(
          (f) =>
            (f.Descripcion.toLocaleLowerCase() as string).indexOf(
              filtroTrimed
            ) > -1 ||
            (f.NoParteInterno.toLocaleLowerCase() as string).indexOf(
              filtroTrimed
            ) > -1
        );
    }

    this.tableComp.setData(filterdata);
  } 
}
